/** NotFoundPage — fallback route. */
import { Link } from 'react-router-dom';
import { NOT_FOUND } from '@/constants/testIds';

export default function NotFoundPage() {
	return (
		<div
			data-testid={NOT_FOUND.page}
			className="mx-auto flex min-h-screen max-w-2xl flex-col items-center justify-center px-6 text-center"
			style={{ fontFamily: "'Poppins', system-ui, sans-serif" }}
		>
			<span className="text-6xl font-extrabold text-emerald-300">404</span>
			<p className="mt-3 text-slate-400">Pagina non trovata.</p>
			<Link
				data-testid={NOT_FOUND.homeLink}
				to="/"
				className="mt-6 rounded-full bg-emerald-400 px-5 py-2 text-sm font-semibold text-slate-950 transition-transform hover:-translate-y-0.5"
			>
				Torna alla home
			</Link>
		</div>
	);
}
